import React from 'react';

export const ProjectActivityContext = React.createContext({});

export const useProjectActivityContext = () =>
  React.useContext(ProjectActivityContext);
